import { Injectable } from '@angular/core';
import { links, tables } from './reference-data.static';
import {
  ReferenceDataLinkSource,
  ReferenceDataSet,
  ReferenceDataSetMapSource,
  ReferenceDataSetSource,
} from './reference-data.types';

@Injectable({
  providedIn: 'root',
})
export class ReferenceDataService {
  protected tablesMap: ReferenceDataSetSource = {};
  protected optionsMap: ReferenceDataSetMapSource = {};
  protected linksMap: ReferenceDataLinkSource = {};

  constructor() {
    this.load();
  }

  load() {
    // Get Table Maps
    for (const itemSetName in tables) {
      const isNameUpper = itemSetName.toUpperCase();
      this.tablesMap[isNameUpper] = tables[itemSetName];
      this.optionsMap[isNameUpper] = this.optionsMap[isNameUpper] ?? {};
      const itemSet = tables[itemSetName];
      for (const item of itemSet) {
        this.optionsMap[isNameUpper][item.code.toUpperCase()] = item;
      }
    }

    // Generate Link Sources
    for (const itemLink of links) {
      const ctUpper = itemLink.coverageCode.toUpperCase();
      const tableUpper = itemLink.table.toUpperCase();
      this.linksMap[ctUpper] = this.linksMap[ctUpper] ?? {};
      this.linksMap[ctUpper][tableUpper] = this.linksMap[ctUpper][tableUpper] ?? [];
      this.linksMap[ctUpper][tableUpper].push(this.optionsMap[tableUpper][itemLink.code.toUpperCase()]);
    }
  }

  getReferenceDataSet(refDataSetName: string): ReferenceDataSet | undefined {
    return this.tablesMap[refDataSetName.toUpperCase()];
  }

  getReferenceDataSetByCoverageCode(coverageCode: string, refDataSetName: string): ReferenceDataSet | undefined {
    return this.linksMap[coverageCode.toUpperCase()][refDataSetName.toUpperCase()];
  }

  getReferenceDataSetValue(refDataSetName: string, code: string): string {
    if (code === null) {
      return 'Unknown';
    }
    return this.optionsMap[refDataSetName.toUpperCase()][code.toUpperCase()]?.name;
  }
}
